import styled from 'styled-components';

export const StyledPlan = styled.div`
  .brewing-method-box {
    margin: 30px 0;
  }

  .errors-box {
    margin: 30px 0;
  }

  .items-to-free-shipping {
    color: #00a107;
    border-radius: ${props => props.theme.borderRadius};
    font-size: ${props => props.theme.fontSizes.small};
    text-align: center;
    margin: -10px 0 15px;
  }

  .plans {
    margin: 0 -170px;
    display: flex;
    justify-content: space-between;

    .popular-tag {
      position: absolute;
      top: 0;
      left: 0;
    }

    .plan-free-shipping {
      font-weight: bold;
      color: #00a107;
      text-transform: uppercase;
      font-size: ${props => props.theme.fontSizes.small};
    }

    .plan-icon {
      height: 50px;
      text-align: center;
      margin: 0 0 20px;

      img {
        height: 100%;
      }
    }

    .plan-option {
      width: 32.5%;
      text-align: center;

      .selectable {
        padding: 15px;
      }

      .title {
        font-weight: 500;
        font-size: ${props => props.theme.fontSizes.large};
      }

      .description {
        font-size: ${props => props.theme.fontSizes.small};
        opacity: 0.7;
      }

      .price {
        margin: 20px -14px -14px;
        padding: 15px;
        background: #f8f8f8;
        line-height: 1;

        .plan-price {
          font-size: ${props => props.theme.fontSizes.large};
        }

        small {
          opacity: 0.7;
          position: relative;
          text-transform: lowercase;
        }

        .plan-shipping {
          display: block;
          font-size: ${props => props.theme.fontSizes.small};
          margin: 5px 0 0;
          opacity: 0.7;
        }
      }

      .brewing-method {
        text-align: left;
        margin: 0 -10px;
      }

      .plan-items {
        text-align: left;
        padding: 0 10px 0 25px;
        margin: 20px 0 0;

        .item {
          font-size: ${props => props.theme.fontSizes.small};

          & + .item {
            margin-top: 8px;
            padding-top: 8px;
            border-top: 1px ${props => props.theme.colors.border} dotted;
          }
        }
      }

      &.current {
        .title, .price {
          color: ${props => props.theme.colors.primary};
        }

        .price {
          background: #fff7f5;
        }
      }
    }
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}) {
    .plans-wrapper {
      position: relative;
      margin: 0 -15px;

      &:before {
        content: '';
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        width: 30px;
        background: rgb(211,212,208);
        background: linear-gradient(90deg, rgba(200,200,200,1) 0%, rgba(255,255,255,0) 100%);
        z-index: 1;
      }

      &:after {
        content: '';
        position: absolute;
        height: 100%;
        top: 0;
        right: 0;
        width: 30px;
        background: rgb(211,212,208);
        background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(200,200,200,1) 100%);
        z-index: 1;
      }
    }

    .plans {
      overflow-x: scroll;
      margin: 0;
      padding: 0 45px;

      .plan-icon {
        margin-bottom: 15px;
      }

      .plan-option {
        width: auto;

        .selectable {
          width: 270px;
        }

        & + .plan-option {
          margin-left: 10px;
        }
      }
    }
  }
`

export const StyledProducts = styled.div`
  margin: 30px 0 60px;

  .product {
    padding-top: 28.8%;
    background-position: center;
    background-size: cover;
    position: relative;
    border: 1px ${props => props.theme.colors.border} solid;
    border-radius: ${props => props.theme.borderRadius};

    .stock-warning {
      position: absolute;
      width: 100%;
      bottom: -30px;
      line-height: 30px;
      font-size: ${props => props.theme.fontSizes.small};
      text-align: center;
    }

    .checkbox {
      position: absolute;
      top: 50%;
      right: 15px;
      margin-top: -20px;
    }
  }

  @media(max-width: ${props => props.theme.breakpoints.tablet}) {
    .product {
      .checkbox {
        right: 6px;
        padding: 0px 10px 0px;
      }
    }
  }
`